import React from 'react';

function AxisLaneDebugOverlay({ lanes = [] }) {
  if (!lanes || lanes.length === 0) return null;
  return (
    <g pointerEvents="none" opacity={0.9}>
      {lanes.map((lane, idx) => {
        if (!lane) return null;
        const key = `${lane.axisSide || 'axis'}-${idx}`;
        const clampedColor = lane.clamped ? '#C44B3D' : '#2D4DB9';
        if (lane.axisSide === 'left') {
          const spineX = lane.spineX ?? 0;
          const spineY1 = lane.spineY1 ?? 0;
          const spineY2 = lane.spineY2 ?? 0;
          const tickX = spineX - (lane.tickLabelOffsetPx ?? 0);
          const titleX = spineX - (lane.titleOffsetPx ?? 0);
          const labelY = (spineY1 + spineY2) / 2;
          return (
            <g key={key}>
              <line x1={spineX} y1={spineY1} x2={spineX} y2={spineY2} stroke="#00A3FF" strokeWidth={1} />
              <line x1={tickX} y1={spineY1} x2={tickX} y2={spineY2} stroke="#00C49A" strokeDasharray="4 2" strokeWidth={1} />
              <line x1={titleX} y1={spineY1} x2={titleX} y2={spineY2} stroke={clampedColor} strokeDasharray="2 2" strokeWidth={1} />
              <circle cx={titleX} cy={labelY} r={2} fill={clampedColor} />
            </g>
          );
        }
        if (lane.axisSide === 'right') {
          const spineX = lane.spineX ?? 0;
          const spineY1 = lane.spineY1 ?? 0;
          const spineY2 = lane.spineY2 ?? 0;
          const tickX = spineX + (lane.tickLabelOffsetPx ?? 0);
          const titleX = spineX + (lane.titleOffsetPx ?? 0);
          const labelY = (spineY1 + spineY2) / 2;
          return (
            <g key={key}>
              <line x1={spineX} y1={spineY1} x2={spineX} y2={spineY2} stroke="#00A3FF" strokeWidth={1} />
              <line x1={tickX} y1={spineY1} x2={tickX} y2={spineY2} stroke="#00C49A" strokeDasharray="4 2" strokeWidth={1} />
              <line x1={titleX} y1={spineY1} x2={titleX} y2={spineY2} stroke={clampedColor} strokeDasharray="2 2" strokeWidth={1} />
              <circle cx={titleX} cy={labelY} r={2} fill={clampedColor} />
            </g>
          );
        }
        if (lane.axisSide === 'bottom') {
          const spineY = lane.spineY ?? 0;
          const spineX1 = lane.spineX1 ?? 0;
          const spineX2 = lane.spineX2 ?? 0;
          const tickY = spineY + (lane.tickLabelOffsetPx ?? 0);
          const titleY = spineY + (lane.titleOffsetPx ?? 0);
          const labelX = (spineX1 + spineX2) / 2;
          return (
            <g key={key}>
              <line x1={spineX1} y1={spineY} x2={spineX2} y2={spineY} stroke="#00A3FF" strokeWidth={1} />
              <line x1={spineX1} y1={tickY} x2={spineX2} y2={tickY} stroke="#00C49A" strokeDasharray="4 2" strokeWidth={1} />
              <line x1={spineX1} y1={titleY} x2={spineX2} y2={titleY} stroke={clampedColor} strokeDasharray="2 2" strokeWidth={1} />
              <circle cx={labelX} cy={titleY} r={2} fill={clampedColor} />
            </g>
          );
        }
        return null;
      })}
    </g>
  );
}

export default AxisLaneDebugOverlay;
